import { render, staticRenderFns } from "./AgregarCliente.vue?vue&type=template&id=0f98c96b"
import script from "./AgregarCliente.vue?vue&type=script&lang=js"
export * from "./AgregarCliente.vue?vue&type=script&lang=js"
import style0 from "./AgregarCliente.vue?vue&type=style&index=0&id=0f98c96b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports